import { render } from "./ModalLink.vue?vue&type=template&id=67ffadea"
import script from "./ModalLink.vue?vue&type=script&lang=js"
export * from "./ModalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__